<div (click)="customizeLayoutDark()" class="mode">
    <i class="ri-moon-line"></i>
</div>